
import React from 'react';
import { Container } from 'react-bootstrap';
import { motion } from 'framer-motion';

const About = () => {
  return (
    <section id="about" className="about-section py-5 bg-light">
      <Container>
        <h2 className="text-center mb-4">About Us</h2>
        <motion.p
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.5 }}
          className="lead text-center"
        >
          SigisBell is dedicated to providing top-notch services with a focus on customer satisfaction. We are committed to excellence in every aspect of our work.
        </motion.p>
      </Container>
    </section>
  );
}

export default About;
